import { ChangeDetectorRef, Component, EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ShowHavePermissionDirective } from '../../../core/directives/show-have-permission.directive';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HelpService } from '../../../core/services/help/help.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from '../../modules/material/material.module';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ShowHavePermissionDirective,
    FontAwesomeModule,
    RouterModule,
    MaterialModule
    ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
})
export class SidebarComponent {

  @ViewChild('tooltip', { static: false, read: MatTooltip }) tooltip!: MatTooltip;

  menuHelp: boolean = false;
  menuConfiguration: boolean = false;

  open = false;

  @Output() closeMenu: EventEmitter<void> = new EventEmitter();

  @Output() openSidebar: EventEmitter<boolean> = new EventEmitter();

  toolTipOpen = '';
  toolTipoClose = '';

  toolTipMessage = '';

  constructor(
    public router: Router,
    private helpService: HelpService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  redirect(item: string) {
    this.router.navigate([item])
  }

  openHelp() {
    this.helpService.showHelp();
    this.closeMenu.emit();
  }

  changeMenus(menuId: string){
    if(!this.open){
      return 
    }
    switch(menuId) {
      case "help" : {
        this.menuHelp = !this.menuHelp;
        break;
      }
      case "configuration" : {
        this.menuConfiguration = !this.menuConfiguration;
        break;
      }
    }

  }
  toogleMenu() {
    this.open = !this.open;
    this.menuHelp = false;
    this.menuConfiguration = false;
    this.tooltip.show();
    this.openSidebar.emit(this.open)
    this.toolTipMessage = this.open ? this.translate.instant('common-page.sidebar.close') : this.translate.instant('common-page.sidebar.expand');
  }

  ngAfterViewInit() {
    const width = window.innerWidth;
    if (width >= 1400) {
      this.open = true;
    }
    this.translate.onLangChange.subscribe(() => {
      this.toolTipMessage = this.open ? this.translate.instant('common-page.sidebar.close') : this.translate.instant('common-page.sidebar.expand');

    })
    this.cdr.detectChanges();
  }
}
